import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TableHeaderRowDefUIDirective } from '../../directives/table-header-row-def.directive';
import { TableResizeUIService } from '../../services/table-resize.service';
import { NgTemplateOutlet } from '@angular/common';
import { TableGetHeaderCellPipe } from '../../pipes/table-get-header-cell.pipe';
import { TableGetOriginalColumnNamePipe } from '../../pipes/table-get-original-column-name.pipe';

@Component({
  selector: 'fr8bot-ui-table-header-row',
  host: {
    '[class.table-resizing]': 'isTableResizing()',
    '[style.grid-template-columns]': 'gridTemplateColumns()',
  },
  templateUrl: './table-header-row.component.html',
  styleUrl: './table-header-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TableGetHeaderCellPipe, TableGetOriginalColumnNamePipe],
})
export class TableHeaderRowUIComponent<DataType> {
  headerRowDefUIDirective = inject<TableHeaderRowDefUIDirective<DataType>>(
    TableHeaderRowDefUIDirective,
    { host: true },
  );
  private resizeService = inject(TableResizeUIService);

  protected readonly isTableResizing = this.resizeService.isTableResizing.asReadonly();
  protected readonly gridTemplateColumns = this.resizeService.gridTemplateColumns;
}
